// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Trend_wrapper__2JYxv","content":"Trend_content__yx2na"};